export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";
export const CREATE_ACCOUNT_FAILED = "CREATE_ACCOUNT_FAILED";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";

export const REQUEST_SUCCESS = "REQUEST SUCCESS";
export const REQUEST_FAILED  = "REQUEST FAILED";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";


//---Company---//
//GetOne
export const COMPANY_GETONE_FAIL    = "COMPANY__GETONE_FAIL";
export const COMPANY_GETONE_SUCCESS = "COMPANY_GETONE_SUCCESS";
//Upsert
export const COMPANY_UPSERT_FAIL    = "COMPANY_UPSERT_FAIL";
export const COMPANY_UPSERT_SUCCESS = "COMPANY_UPSERT_SUCCESS";

//---Users---//
//GetAll
export const USER_GETALL_SUCCESS = "USER_GETALL_SUCCESS";
export const USER_GETALL_FAIL    = "USER_GETALL_FAIL";
//Upsert
export const USER_UPSERT_SUCCESS = "USER_UPSERT_SUCCESS";
export const USER_UPSERT_FAIL    = "USER_UPSERT_FAIL";
//Delete
export const USER_DELETE_SUCCESS = "USER_DELETE_SUCCESS";
export const USER_DELETE_FAIL    = "USER_DELETE_FAIL";

//---Agencies---//
//GetAll
export const AGENCY_GETALL_SUCCESS = "AGENCY_GETALL_SUCCESS";
export const AGENCY_GETALL_FAIL    = "AGENCY_GETALL_FAIL";
//Upsert
export const AGENCY_UPSERT_SUCCESS = "AGENCY_UPSERT_SUCCESS";
export const AGENCY_UPSERT_FAIL    = "AGENCY_UPSERT_FAIL";
//Delete
export const AGENCY_DELETE_SUCCESS = "AGENCY_DELETE_SUCCESS";
export const AGENCY_DELETE_FAIL    = "AGENCY_DELETE_FAIL";

//---Airports--//
export const AIRPORT_UPSERT_SUCCESS = "AIRPORT_UPSERT_SUCCESS";
export const AIRPORT_GETALL_SUCCESS = "AIRPORT_GETALL_SUCCESS";
export const AIRPORT_DELETE_SUCCESS = "AIRPORT_DELETE_SUCCESS";

export const AIRPORT_UPSERT_FAIL = "AIRPORT_UPSERT_FAIL";
export const AIRPORT_GETALL_FAIL = "AIRPORT_GETALL_FAIL";
export const AIRPORT_DELETE_FAIL = "AIRPORT_DELETE_FAIL";

//--BankAccounts--//
export const BANKACCOUNT_UPSERT_SUCCESS = "BANKACCOUNT_UPSERT_SUCCESS";
export const BANKACCOUNT_GETALL_SUCCESS = "BANKACCOUNT_GETALL_SUCCESS";
export const BANKACCOUNT_DELETE_SUCCESS = "BANKACCOUNT_DELETE_SUCCESS";

export const BANKACCOUNT_UPSERT_FAIL = "BANKACCOUNT_UPSERT_FAIL";
export const BANKACCOUNT_GETALL_FAIL = "BANKACCOUNT_GETALL_FAIL";
export const BANKACCOUNT_DELETE_FAIL = "BANKACCOUNT_DELETE_FAIL";

//---Centers--//
export const CENTER_UPSERT_SUCCESS = "CENTER_UPSERT_SUCCESS";
export const CENTER_GETALL_SUCCESS = "CENTER_GETALL_SUCCESS";
export const CENTER_DELETE_SUCCESS = "CENTER_DELETE_SUCCESS";

export const CENTER_UPSERT_FAIL = "CENTER_UPSERT_FAIL";
export const CENTER_GETALL_FAIL = "CENTER_GETALL_FAIL";
export const CENTER_DELETE_FAIL = "CENTER_DELETE_FAIL";

//---Extras---//
export const EXTRA_UPSERT_FAIL    = "EXTRA_UPSERT_FAIL";
export const EXTRA_UPSERT_SUCCESS = "EXTRA_UPSERT_SUCCESS";
export const EXTRA_GETALL_SUCCESS = "EXTRA_GETALL_SUCCESS";
export const EXTRA_GETALL_FAIL = "EXTRA_GETALL_FAIL";

export const BOOKING_GETALL_SUCCESS ="BOOKING_GETALL_SUCCESS"
export const BOOKING_GETALL_FAIL = "BOOKING_GETALL_FAIL"
export const BOOKING_UPSERT_SUCCESS = "BOOKING_UPSERT_SUCCESS"
export const BOOKING_UPSERT_FAIL = "BOOKING_UPSERT_FAIL"
export const BOOKING_DELETE_SUCCESS = "BOOKING_DELETE_SUCCESS"
export const BOOKING_DELETE_FAIL = "BOOKING_DELETE_FAIL"
export const BOOKING_GET_ONE_SUCCESS = "BOOKING_GET_ONE_SUCCESS"
export const BOOKING_GET_ONE_FAIL  = "BOOKING_GET_ONE_FAIL"

